// ChiDi - Chihuahua Digital | Agencia de marketing boutique
// Contenido real extraído del brief del cliente. Diseño heredado (paleta ChiDi + estilo sunset).

export const NAV_LINKS = [
  { label: "Manifiesto", href: "#manifiesto" },
  { label: "Servicios", href: "#servicios" },
  { label: "Proceso", href: "#proceso" },
  { label: "Sobre m\u00ed", href: "#sobre" },
];

export const HERO = {
  eyebrow: "Agencia de marketing boutique",
  title: ["ESTRATEGIA +", "DEDICACIÓN."],
  subtitle:
    "Publicidad Meta Ads para negocios con alma. Sin fórmulas mágicas, solo estrategia real y resultados medibles.",
  primaryCta: { label: "Agendar Auditor\u00eda", href: "#contacto" },
  secondaryCta: { label: "Conocer m\u00e1s", href: "#servicios" },
};

export const MANIFESTO = {
  eyebrow: "Nuestro manifiesto",
  heading: "En lo que creemos.",
  lines: [
    { a: "Las multinacionales tienen presupuesto,", b: "las PYMES tienen alma." },
    { a: "Donde la IA automatiza,", b: "yo me detengo a pensar." },
    { a: "Instagram est\u00e1 saturado;", b: "solo una estrategia con coraz\u00f3n destaca." },
  ],
};

export const SERVICES = {
  eyebrow: "Servicios",
  heading: "C\u00f3mo te ayudo a vender m\u00e1s.",
  subheading: "Estos son los servicios en los que más\u00A0me\u00A0destaco.",
  items: [
    {
      num: "01",
      name: "Meta Ads Pro",
      desc: "Campa\u00f1as enfocadas 100% en ventas y retorno de inversi\u00f3n (ROAS).",
      points: ["Estrategia de conversi\u00f3n", "Optimizaci\u00f3n de presupuesto", "Reporting"],
      color: "#e55b36",
    },
    {
      num: "02",
      name: "Research & Data",
      desc: "Investigaci\u00f3n profunda de tu nicho y audiencia. Pedidos Ad Hoc.",
      points: ["An\u00e1lisis de competencia", "Definici\u00f3n de buyer persona", "Social Listening sobre tu marca, industria o un tema en particular"],
      color: "#b1cdff",
    },
    {
      num: "03",
      name: "Curadur\u00eda Creativa",
      desc: "Te gu\u00edo para que tus anuncios destaquen y se ajusten a los requisitos de Meta.",
      points: ["Ideas de contenido", "Guiones para reels/anuncios", "Estrategia de contenidos."],
      color: "#e55b36",
    },
    {
      num: "04",
      name: "Community Manager",
      desc: "Gestión de redes.",
      points: ["Reels atractivos", "Posts y stories", "Planificación de contenido"],
      color: "#b1cdff",
    },
  ],
};

export const PROCESS = {
  eyebrow: "C\u00f3mo trabajamos",
  heading: "Nuestro proceso.",
  steps: [
    { num: "01", name: "Entender", desc: "Escuchamos e investigamos tu negocio a fondo." },
    { num: "02", name: "Pensar", desc: "Estrategia basada en insights reales." },
    { num: "03", name: "Crear", desc: "Ideas con prop\u00f3sito y creatividad." },
    { num: "04", name: "Escalar", desc: "Optimizaci\u00f3n continua basada en data." },
  ],
};

export const RESULTS = {
  eyebrow: "Casos de \u00e9xito",
  heading: "Resultados reales.",
  subheading: "Mejor trimestre — ene-mar 2026.",
  headline: { value: "58,7x", label: "ROAS", note: "Por cada dólar (USD) invertido en Meta Ads, generamos $58,70 USD en ventas para este cliente." },
  metrics: [
    { value: "1.178", label: "Ventas generadas" },
    { value: "$2.590", label: "Inversión (USD)" },
    { value: "$151.920", label: "Retorno total (USD)" },
    { value: "3,12%", label: "Tasa de conversión" },
  ],
};

export const TESTIMONIALS = {
  eyebrow: "Testimonios",
  heading: "Lo que dicen.",
  items: [
    {
      quote:
        "Excelente profesional, responsable, expeditiva, con real experiencia y capaz de obtener grandes resultados. Estamos muy contentos con su servicio.",
      name: "Carola",
      role: "Mayorista de Deco, We Are Home",
    },
  ],
};

export const FOUNDER = {
  eyebrow: "Sobre m\u00ed",
  name: "Karen G\u00f3mez",
  years: "+8",
  yearsLabel: "A\u00f1os de experiencia",
  role: "Fundadora de ChiDi, publicista y analista de datos",
  bio: "Despu\u00e9s de a\u00f1os trabajando en agencias tradicionales con grandes clientes (Coca-Cola, Chevrolet, Bimbo, Cervecer\u00eda Quilmes) decid\u00ed crear algo diferente. ChiDi naci\u00f3 de la necesidad de aportar mi creatividad y experiencia a negocios que realmente lo necesiten.",
  linkedin: "https://www.linkedin.com/in/karengomezok/",
  worked: ["Coca-Cola", "Chevrolet", "Quilmes", "AB InBev"],
};

export const CONTACT = {
  eyebrow: "Contacto",
  heading: "Hablemos.",
  subheading: "¿Tenés un proyecto en mente? ¿Necesitás una estrategia que realmente funcione? Contame de vos primero.",
  email: "contacto@chidimarketing.com",
  location: "Buenos Aires, Argentina",
  form: {
    title: "Antes de agendar una llamada, contame de tu negocio.",
    intro:
      "Este es un formulario para entender si estamos alineados. Por favor, completá esto en 1 minuto para dar el salto.",
    submitLabel: "Enviar",
    success: {
      title: "Recibido.",
      text: "Voy a revisar tu respuesta y, si veo que podemos ayudarte, te escribo para coordinar una llamada. Gracias por tomarte el tiempo de responder con números reales.",
    },
    fields: [
      { name: "nombre", label: "Nombre y apellido", type: "text", placeholder: "Tu nombre y apellido", required: true },
       { name: "email", label: "Email", type: "text", placeholder: "tu@email.com", required: true },
      { name: "empresa", label: "Empresa o marca", type: "text", placeholder: "Nombre de tu empresa o marca", required: true },
      { name: "web", label: "Sitio web / Instagram", type: "text", placeholder: "tuweb.com o @tuinstagram", required: true },
      {
        name: "tipoNegocio", label: "Tipo de negocio", type: "select", required: true, placeholder: "Elegí una opción",
        options: ["Mayorista / Fábrica", "Minorista", "Servicios", "Otro"],
      },
      {
        name: "rubro", label: "¿A qué rubro pertenece tu marca?", type: "select", required: true, placeholder: "Elegí una opción",
        options: ["Moda / Indumentaria", "Decoración / Hogar", "Alimentos y bebidas", "Belleza y cosmética", "Tecnología", "Otro"],
      },
      {
        name: "presupuesto", label: "¿Cuánto podés destinar hoy a pauta en Meta Ads por mes?", type: "select", required: true, placeholder: "Elegí un rango",
        options: ["Menos de USD 300", "USD 300 – 800", "USD 800 – 1.500", "USD 1.500 – 3.000", "Más de USD 3.000"],
        help: "Sin presupuesto de pauta, la estrategia no tiene con qué moverse — por eso lo pregunto directo.",
      },
      {
        name: "frustracion", label: "¿Qué es lo que más te frustra hoy de tu marketing?", type: "select", required: true, placeholder: "Elegí una opción",
        options: ["No estoy llegando al público que quiero", "Tengo pocas ventas", "Mi agencia actual no me escucha ni me explica nada", "Siento que estoy tirando la plata en pauta", "Quiero escalar el negocio pero no sé cómo hacerlo bien", "Otro"],
      },
      { name: "mensaje", label: "Mensaje", type: "textarea", placeholder: "Contame lo que quieras agregar (opcional)", required: false },
    ],
  },
};
